
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BoPanel, IOnOffHandlers } from 'bonomo';
import { IErrors } from '@/model/IErrors';
import { IShortUser } from '@/model/shortInterfaces';
import axios from 'axios';
import { settings } from '@/plugins/settings';

const clientModule = namespace('clientModule');

@Component({
  name: 'BusinessClientCreate',
  components: { BoPanel },
})
export default class BusinessClientCreate extends Vue {
  @clientModule.Getter('errors')
  protected errors!: IErrors;

  @clientModule.Action('createBusinessClient')
  private createClient!: (data: any) => Promise<any>;

  protected loading: boolean = false;
  protected saving: boolean = false;
  private subscribes: IOnOffHandlers = {};

  private form: any = {
    name: '',
    legal_name: '',
    principal_contact: null,
    invoicing_contact: null,
  };

  principalSearch: string = '';
  invoicingSearch: string = '';
  principalContactItems: IShortUser[] = [];
  invoicingContactItems: IShortUser[] = [];
  loadingPrincipal: boolean = false;
  loadingInvoicing: boolean = false;
  private principalTimer: any = null;
  private invoicingTimer: any = null;

  private rules = {
    required: (v: any) => !!v || this.$t('common.validation.required'),
    min2: (v: string) => (v && v.length >= 2) || this.$t('common.validation.min', { min: 2 }),
  };

  @Watch('principalSearch')
  onPrincipalSearch(val: string) {
    if (!val || val.length < 3) { this.principalContactItems = []; return; }
    clearTimeout(this.principalTimer);
    this.principalTimer = setTimeout(() => this.searchUsers(val, 'principal'), 400);
  }

  @Watch('invoicingSearch')
  onInvoicingSearch(val: string) {
    if (!val || val.length < 3) { this.invoicingContactItems = []; return; }
    clearTimeout(this.invoicingTimer);
    this.invoicingTimer = setTimeout(() => this.searchUsers(val, 'invoicing'), 400);
  }

  private async searchUsers(search: string, field: 'principal' | 'invoicing') {
    if (field === 'principal') this.loadingPrincipal = true;
    else this.loadingInvoicing = true;

    try {
      const response = await axios.get(settings.endpoint + 'users', { params: { search, active_only: 1 } });
      const payload = response.data && response.data.data;
      const items: IShortUser[] = Array.isArray(payload) ? payload : (Array.isArray(payload && payload.data) ? payload.data : []);
      if (field === 'principal') this.principalContactItems = items;
      else this.invoicingContactItems = items;
    } finally {
      if (field === 'principal') this.loadingPrincipal = false;
      else this.loadingInvoicing = false;
    }
  }

  created() {
    this.subscribes = this.$ons({
      'backend.call.begin.businessClientCreated': () => { this.saving = true; },
      'backend.call.OK.businessClientCreated': this.onCreateSuccess,
      'backend.call.KO.businessClientCreated': () => { this.saving = false; },
    });
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  loadData() {}

  private onSave() {
    this.createClient({ ...this.form });
  }

  private onCreateSuccess(client: any) {
    this.saving = false;
    this.$uiBus.emit('success', this.$t('common.saved'));
    if (client && client.id) {
      this.$router.push({ name: 'businessClient', params: { clientId: '' + client.id } });
    } else {
      this.$router.push({ name: 'businessClientList' });
    }
  }

  private onCancel() {
    this.$router.push({ name: 'businessClientList' });
  }
}
